export default __webpack_public_path__ + "static/oryx-d31ca77c968f4d105887a4776d77a910.jpg";